import Image from "next/image";

type props = {
  code: string;
  width?: number;
  height?: number;
  circle?: boolean;
};

export default function Flag({ code, width = 20, height = 14, circle = false }: props) {
  if (!circle) {
    return <Image src={`/flags/${code}.svg`} alt={code} width={width} height={height} />;
  }

  return (
    <div className="relative rounded-full overflow-hidden shrink-0 ring-1 ring-black/[0.06]" style={{ width: width, height: height }}>
      <Image
        src={`/flags/${code.toLowerCase()}.svg`}
        alt={code}
        fill
        className="object-cover"
        sizes={`${width}px`}
      />
    </div>
  );
}
